import flatpickr from 'flatpickr';
import {German} from 'flatpickr/dist/l10n/de';

class InputDateTime {
    constructor(input) {
        this.input = input;
        this.inputConfig = {};
        this.picker = flatpickr;

        this.init();
    }

    set config(input) {
        const {dateTimeConfig} = input.dataset;

        if (!dateTimeConfig) return;

        this.inputConfig = {...this.inputConfig, ...JSON.parse(dateTimeConfig)};
    }

    get config() {
        return this.inputConfig;
    }

    init() {
        this.config = this.input;

        if (this.config.locale === 'de-DE') {
            this.config.locale = German;
        }

        this.picker(this.input, this.config);
    }
}

const inputDateTime = {
    init() {
        const inputs = document.querySelectorAll('.js-input-date-time');

        if (!inputs.length) return;

        this.inputDateTime = [];

        inputs.forEach((input) => {
            this.inputDateTime.push(new InputDateTime(input));
        });
    },
};

export default inputDateTime;
